/**
 * Категории событий
 *
 * @name constants.EVENTS
 * @type {Record<string, string>}
 */
export const CATEGORIES: Record<string, string> = {
    applicationForm: 'application_form',
    applicationButton: 'application_button',
    landing: 'landing',
    fullBuy: 'fullbuy',
    tariffCards: 'tariff_cards',
    fullBuyEquip: 'full-buy-equip',
};

/**
 * Тип действия событий
 *
 * @name constants.ACTIONS
 * @type {Record<string, string>}
 */
export const ACTIONS: Record<string, string> = {
    started: 'started',
    finished: 'finished',
    success: 'success',
    error: 'error',
    click: 'click',
    view: 'view',
    popup: 'popup',
    clickChooseTariff: 'click choose tariff',
};

/**
 * Типы событий
 *
 * @name constants.EVENTS
 * @type {Record<string, string>}
 */
export const EVENTS: Record<string, string> = {
    UAevent: 'UAevent',
};
